module.exports = __webpack_public_path__ + "img/email.c329727a.svg";